import { Header } from '@/components/header'
import { Footer } from '@/components/footer'
import { AssociationsAndSuppliers } from '@/components/AssociationsAndSuppliers'
import { Helmet } from 'react-helmet-async'

// Environment variables
const JOBBER_ORG_ID = import.meta.env.VITE_JOBBER_ORGANIZATION_ID || '';

export default function Appointment() {
  return (
    <main>
      <Helmet>
        <title>Book a Consultation | Busy Beaver Construction | Calgary Deck Builder</title>
        <meta name="description" content="Schedule a free on-site consultation with Busy Beaver Construction for your custom deck, fence, or outdoor living space project in Calgary. No obligation consultations." />
        <meta name="keywords" content="book deck consultation, Calgary deck builder, deck estimate, fence consultation Calgary, outdoor living space consultation, free deck quote" />
        <link rel="canonical" href="https://busybeaverconstruction.com/appointment" />
        <meta property="og:title" content="Book a Consultation | Busy Beaver Construction" />
        <meta property="og:description" content="Request a free, no-obligation consultation with Calgary's premier deck and fence builder. Get professional advice for your outdoor living space project." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://busybeaverconstruction.com/appointment" />
        <meta property="og:image" content="https://busybeaverconstruction.com/assets/images/Decks/Composite Decks/timbertech-composite-stock.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="preload" href="/assets/images/Decks/Composite Decks/timbertech-composite-stock.jpg" as="image" />
      </Helmet>
      <Header />

      {/* Hero Banner */}
      <section className="relative h-[400px] flex items-center justify-center">
        <img 
          src="/assets/images/Decks/Composite Decks/timbertech-composite-stock.jpg"
          alt="Custom TimberTech composite deck installation by Busy Beaver Construction in Calgary"
          className="absolute inset-0 w-full h-full object-cover loading-eager"
          fetchPriority="high"
        />        
        <div className="relative z-10 mt-64 text-center">
          <div className="inline-block bg-busy-green rounded py-3 mx-4 px-4 lg:px-8">
            <p className="text-white text-base font-medium rounded">The Longest Operating Deck Builder in Calgary</p>
          </div>
        </div>
      </section>

      {/* Appointment Content */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container">
          <h1 className="text-center text-5xl lg:text-6xl font-primary mb-10">Request an Onsite Estimate</h1>
          
          <div className="max-w-3xl mx-auto">
            <p className="text-center mb-8 text-gray-600">
              Request a consultation with Busy Beaver Construction using our online form below. 
              Tell us about your project, and we'll be in touch to schedule an appointment.
            </p>
            
            {/* Jobber Widget Container */}
            <div className="border border-gray-200 rounded-lg shadow-sm p-6 bg-white relative">
              <div className="jobber-inline-work-request h-[1830px] lg:h-[1508px]" >
                <iframe 
                  className="jobber-work-request"
                  src={`https://clienthub.getjobber.com/client_hubs/${JOBBER_ORG_ID}/public/work_request/embedded_new?source=embedded_inline`}
                  sandbox="allow-forms allow-scripts allow-same-origin allow-modals"
                  style={{ 
                    visibility: 'visible',
                    width: '100%',
                    border: 'none'
                  }}
                  title="Busy Beaver Construction Consultation Request Form"
                />
              </div>
            </div>
            
            <div className="mt-8 text-center text-sm text-gray-500">
              <p>If you prefer to request a consultation by phone, please call us at <a href="tel:4032865400" className="text-beaver-red font-bold">(403) 286-5400</a></p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Associations and Suppliers Section */}
      <AssociationsAndSuppliers />
      <Footer />
    </main>
  )
} 